<template>
  <div class="service-container" :style="containerStyle">
    <fda-search
      v-model:cate="areaCode"
      v-model:keyword="searchWords"
      :style="searchStyle"
      :options="SEARCH_AREA"
      class-prefix="fda-icon"
      @do-search="onSearch"
    />
    <van-list v-model:loading="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
      <fda-info-item
        v-for="item in list"
        :key="item.id"
        :item="item"
        :title="item.name"
        :number="item.distance"
        :text="item.addr"
        @click="areaItemClick"
      />
    </van-list>
  </div>
</template>
<script lang="ts" setup>
import { useConfigStore } from '@/store/modules/config';
import { useMedicalOrgStore } from '@/store/modules/medicalOrg';
import { useRecordsStore } from '@/store/modules/records';
import { useContractStore } from '@/store/modules/contract';
import { useAppStore } from '@/store/modules/app';
import { TMedicalOrgSimple, ReqMedicalOrg } from '@tencent/fd-types/patient';
import { t } from '@/assets/theme';
import { Nullable } from '@/types/global';
import { router } from '@/router';

const configStore = useConfigStore();
const medicalOrgStore = useMedicalOrgStore();
const recordsStore = useRecordsStore();
const appStore = useAppStore();
const contractStore = useContractStore();
interface SignOrgProps {
  top?: number;
}

const props = withDefaults(defineProps<SignOrgProps>(), {
  top: 0,
});

const SEARCH_AREA = configStore.getFirstLevelAreaCode();
const areaCode = ref<number | string>(0);
const searchWords = ref('');

const list = ref<Nullable<TMedicalOrgSimple[]>>([]);
const loading = ref(false);
const finished = ref(false);
const finishedText = ref('没有更多了');

const containerStyle = computed(() => ({
  marginTop: t(props.top),
}));
const searchStyle = computed(() => ({
  top: t(props.top),
}));
onMounted(() => {
  medicalOrgStore.resetPage();
});
const onLoad = async () => {
  const req: ReqMedicalOrg = {
    lat: Number(appStore.lat),
    lng: Number(appStore.lng),
    searchBy: { medicalOrgName: '', areaCode: [] },
    page: {
      page: medicalOrgStore.page + 1,
      pageSize: 10,
    },
  };
  if (areaCode.value && req.searchBy) {
    req.searchBy.areaCode = [areaCode.value.toString()];
  }
  if (searchWords.value && req.searchBy) {
    req.searchBy.medicalOrgName = searchWords.value;
  }
  const res = await medicalOrgStore.fetchMedicalOrg(req);

  if (!res.page.totalPages) {
    // 无法查到结果
    loading.value = false;
    finished.value = true;
    finishedText.value = '暂无结果';
    return;
  }

  if (res.list?.length) {
    list.value?.push(...res.list);
  }

  loading.value = false;

  if (medicalOrgStore.page >= medicalOrgStore.totalPageNum) {
    finished.value = true;
    finishedText.value = '没有更多了';
  }
};

const onSearch = () => {
  console.log(areaCode.value, searchWords.value);
  medicalOrgStore.resetPage();
  list.value = [];
  finished.value = false;
  loading.value = true;
  onLoad();
  console.log('onSearch');
};

const areaItemClick = (item) => {
  console.log('areaItemClick', item);
  recordsStore.setRecordsItem('org', item);
  recordsStore.setRecordsItem('signOrg', item.id);
  contractStore.setSignOrg(item.id);
  contractStore.setSignOrgName(item.name);
  console.log('setRecordsItem', recordsStore.getRecordsItem('org'));
  router.go(-1);
};
</script>
<style scoped lang="less">
.fda-search {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2;
}

.van-list {
  position: relative;
  z-index: 1;
  padding-top: 112px;
}

.service-container {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
}
</style>
